 angular
   .module('vppApp')
   .directive('passwordReveal', passwordReveal);

 function passwordReveal() {
   return {
     transclude: true,
     template: '<div class="password-reveal-wrapper"><i class="password-reveal-icon"></i><div ng-transclude></div></div>',
     compile: function() {

       return function(scope, element, attr) {

         let isVisible = false;
         let passwordWrapper = element[0].querySelector('.password-reveal-wrapper');
         let passwordWrapperIcon = element[0].querySelector('.password-reveal-icon');
         let passwordWrapperInput = element[0].querySelector('input');
         angular.element(passwordWrapperIcon).bind("click", function(event) {
            isVisible = !isVisible;
            if(isVisible){
              angular.element(passwordWrapper).addClass('show-password');
             angular.element(passwordWrapperInput).attr("type", "text");
            } else {
              angular.element(passwordWrapper).removeClass('show-password');
             angular.element(passwordWrapperInput).attr("type", "password");
            }
         });
       };
     }
   };
 }
